import { CognitoUser, User } from '../../types';
import { createAction } from '@reduxjs/toolkit';

export const setUser = createAction<User>('auth/setUser');
export const setFirstTimeUser = createAction<CognitoUser>('auth/firstTimeUser');
export const logoutUser = createAction('auth/logout');
